module.exports = __webpack_public_path__ + "/build/web/svg/ic-chevron-right-black-24-px.f52a2af8ce36ef63230a5869c281d824.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/ic-chevron-right-black-24-px.svg
// module id = 220
// module chunks = 13